import type { IQPV, LngLat } from "@bbj-types/address";
import { buildMakeUseAxios } from "@root/api/api.tools";
import { useCallback } from "react";

const axios = buildMakeUseAxios(`${import.meta.env.VITE_TRANSPORT_SERVICE_URL}`);

export const useGetIsQpv = () => {
  const [state, execute, cancel] = axios<IQPV, undefined, unknown>(
    {
      url: "/v2/transport/isQPV",
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (loc: LngLat) => {
      return execute({ params: { loc } });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
